export default "__VITE_ASSET__Buu0iWTL__"